import { application } from "./application"

import AuthorTagInputController from "./author_tag_input_controller"
import PeopleChartsController from "./people_charts_controller"
import PeopleIndexChartController from "./people_index_chart_controller"
import PeopleRowsController from "./people_rows_controller"
import AuthorLinkSearchController from "./author_link_search_controller"
import AutoRefreshController from "./auto_refresh_controller"
import AlertFormController from "./alert_form_controller"
import AutoOpenDialogController from "./auto_open_dialog_controller"
import AlertTransferController from "./alert_transfer_controller"
import AlertsTableController from "./alerts_table_controller"
import BrandVariationsController from "./brand_variations_controller"
import ChannelSelectController from "./channel_select_controller"
import ChannelComboboxController from "./channel_combobox_controller"
import ChannelListRefreshController from "./channel_list_refresh_controller"
import NotificationTestController from "./notification_test_controller"
import OverflowMenuController from "./overflow_menu_controller"
import ColorPickerController from "./color_picker_controller"
import CommentViewController from "./comment_view_controller"
import CopyLinkController from "./copy_link_controller"
import FeedFiltersController from "./feed_filters_controller"
import HeaderSearchController from "./header_search_controller"
import FeedModeController from "./feed_mode_controller"
import FeedProgressController from "./feed_progress_controller"
import FeedSelectionController from "./feed_selection_controller"
import FormController from "./form_controller"
import LightboxController from "./lightbox_controller"
import LinkActionsController from "./link_actions_controller"
import PopoverController from "./popover_controller"
import InfiniteScrollController from "./infinite_scroll_controller"
import ScrollTopController from "./scroll_top_controller"
import SentimentOverrideController from "./sentiment_override_controller"
import StreamFetchController from "./stream_fetch_controller"
import PlatformScrapeController from "./platform_scrape_controller"
import RevealController from "./reveal_controller"
import RoutingCascadeController from "./routing_cascade_controller"
import ReviewRoutingCascadeController from "./review_routing_cascade_controller"
import ToastController from "./toast_controller"
import ToastTriggerController from "./toast_trigger_controller"
import UserMenuController from "./user_menu_controller"
import TranslationController from "./translation_controller"
import TriageController from "./triage_controller"
import ThreadNavigatorController from "./thread_navigator_controller"
import SearchController from "./search_controller"
import TermEstimatorController from "./term_estimator_controller"
import SlugController from "./slug_controller"
import ReviewAlertSaveBarController from "./review_alert_save_bar_controller"

application.register("author-tag-input", AuthorTagInputController)
application.register("people-charts", PeopleChartsController)
application.register("people-index-chart", PeopleIndexChartController)
application.register("people-rows", PeopleRowsController)
application.register("author-link-search", AuthorLinkSearchController)
application.register("auto-refresh", AutoRefreshController)
application.register("alert-form", AlertFormController)
application.register("auto-open-dialog", AutoOpenDialogController)
application.register("alert-transfer", AlertTransferController)
application.register("alerts-table", AlertsTableController)
application.register("brand-variations", BrandVariationsController)
application.register("channel-select", ChannelSelectController)
application.register("channel-combobox", ChannelComboboxController)
application.register("channel-list-refresh", ChannelListRefreshController)
application.register("notification-test", NotificationTestController)
application.register("overflow-menu", OverflowMenuController)
application.register("color-picker", ColorPickerController)
application.register("comment-view", CommentViewController)
application.register("copy-link", CopyLinkController)
application.register("feed-filters", FeedFiltersController)
application.register("header-search", HeaderSearchController)
application.register("feed-mode", FeedModeController)
application.register("feed-progress", FeedProgressController)
application.register("feed-selection", FeedSelectionController)
application.register("form", FormController)
application.register("lightbox", LightboxController)
application.register("link-actions", LinkActionsController)
application.register("popover", PopoverController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("scroll-top", ScrollTopController)
application.register("platform-scrape", PlatformScrapeController)
application.register("sentiment-override", SentimentOverrideController)
application.register("stream-fetch", StreamFetchController)
application.register("reveal", RevealController)
application.register("routing-cascade", RoutingCascadeController)
application.register("review-routing-cascade", ReviewRoutingCascadeController)
application.register("toast", ToastController)
application.register("toast-trigger", ToastTriggerController)
application.register("user-menu", UserMenuController)
application.register("translation", TranslationController)
application.register("triage", TriageController)
application.register("thread-navigator", ThreadNavigatorController)
application.register("search", SearchController)
application.register("term-estimator", TermEstimatorController)
application.register("slug", SlugController)
application.register("review-alert-save-bar", ReviewAlertSaveBarController)

window.toast = (message, options = {}) => {
  window.dispatchEvent(new CustomEvent("toast:show", { detail: { message, ...options } }))
}
